"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { captureReferralCode } from "@/lib/referral";

/* Invisible — watches every navigation for ?ref=APEX-XXXXXX and
 * persists it (30-day localStorage TTL). Both checkout routes read
 * the stored code at purchase time so attribution survives however
 * long the visitor browses before buying.
 *
 * Mounted in the root layout inside a Suspense boundary (Next
 * requires one around useSearchParams). Renders nothing. */
const BACKEND = (
  process.env.NEXT_PUBLIC_BACKEND_API_BASE || "https://www.apexflowlabs.com"
).replace(/\/$/, "");

export function ReferralCapture() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const ref = searchParams?.get("ref");
    if (!ref) return;
    captureReferralCode(ref);
    /* Record the click for the affiliate program (Gate 8). Fire-and-forget;
     * a failed ping must never affect the page. keepalive so it survives the
     * landing→navigation. */
    try {
      fetch(`${BACKEND}/api/v1/affiliate/click`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          code: ref,
          path: typeof window !== "undefined" ? window.location.pathname : undefined,
        }),
        keepalive: true,
      }).catch(() => {});
    } catch {
      /* ignore */
    }
  }, [searchParams]);

  return null;
}
